import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import GlobalStyles from "@mui/material/GlobalStyles";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { useFormik, FieldArray, getIn, FormikProvider } from "formik";
import { useNavigate, useLocation } from "react-router-dom";
import JoinusValidation from "../../../validation/joinusValidation";

import TopBar from "../../../components/TopBarV2";
import { useContext } from "react";
import { AuthUserContext } from "../../../providers/AuthProvider";
import GoogleIcon from "@mui/icons-material/Google";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import AddIcon from "@mui/icons-material/Add";
import { useIntl } from "react-intl";
import Spinner from "../../../components/spinner";
import Stepper from "../../../components/stepper";
import Paper from "@mui/material/Paper/Paper";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import CloseIcon from "@mui/icons-material/Close";
import Checkbox from "@mui/material/Checkbox/Checkbox";
import * as Yup from "yup";
import Slider from "@mui/material/Slider";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip/Tooltip";
import ScrollToTop from "../../../utils/scrollTop";


const helpers=[
	{
		id:1,
		text:""
	}
]


export default function AdditionalDetailsComponent(props) {
	const [loading, setLoading] = React.useState(false);
	const [selected, setSelected] = React.useState("");
	const [checkA, setCheckA] = React.useState(true);
	const [checkB, setCheckB] = React.useState(false);
	const [checkD, setCheckD] = React.useState("");
	const [checkE, setCheckE] = React.useState("");
	const [checkF, setCheckF] = React.useState("");
	const [checkG, setCheckG] = React.useState("");
	const [checkH, setCheckH] = React.useState("");
	const [colorChange, setColor] = React.useState('');
	const { user, setUser, profile, setProfile } = useContext(AuthUserContext);
	const navigator = useNavigate();
	const location = useLocation();
	const { messages } = useIntl();

	const [checka, setChecka] = React.useState(false);
	const [checkb, setCheckb] = React.useState(false);
	const [checkc, setCheckc] = React.useState(false);
	const [checkd, setCheckd] = React.useState(false);
	let valueToBeCalculated = 0;
	const limitOfAnYear = 107000;
	let percentage = 0;
	const previousInvestment = 0;
	let amountTheyCanInvest = 0;
	let initialValue = 0;
	let value1 = valueToBeCalculated;
	function Valuesupdate() {
		return `${initialValue.replace(value1)}`;
	}

	const [amt, setAmt] = React.useState(0);
	const [calculator, setCalculator] = React.useState(0);
	const [totalAnualIncome, settotalAnualIncome] = React.useState(
		props?.value ?? 0
	);
	const [totalNetWorth, settotalNetWorth] = React.useState(props?.value ?? 0);
	const [external, setExternal] = React.useState(props?.value ?? 0);
	const [companyAssets, setCompanyAssets] = React.useState(props?.value ?? 0);
	function update1() {
		let companyNetworth = +companyAssets;
		let externalAmount = +external;
		console.log("company networth", companyNetworth);
		let percentage = 0;
		let amountTheyCanInvest = 0;
		if (companyNetworth >= limitOfAnYear) {
			percentage = 10;
			amountTheyCanInvest = (companyNetworth * percentage) / 100;
			if (amountTheyCanInvest > limitOfAnYear) {
				amountTheyCanInvest = limitOfAnYear;
			}
		} else {
			percentage = 5;
			amountTheyCanInvest = (companyNetworth * percentage) / 100;
			if (amountTheyCanInvest <= 2200) {
				amountTheyCanInvest = 2200;
			}
		}

		amountTheyCanInvest -= externalAmount;
		if (amountTheyCanInvest < 0) {
			amountTheyCanInvest = 0;
		}
		console.log(amountTheyCanInvest);
		setCalculator(amountTheyCanInvest);
	}

	function update() {
		setCalculator(0);
		let anualIncome = +totalAnualIncome;
		let networth = +totalNetWorth;
		let externalAmount = +external;
		let valueToBeCalculated = 0;
		let percentage = 0;
		let amountTheyCanInvest = 0;
		if (anualIncome > +networth) {
			valueToBeCalculated = networth;
		} else {
			valueToBeCalculated = anualIncome;
		}
		if (valueToBeCalculated >= limitOfAnYear) {
			percentage = 10;
			amountTheyCanInvest = (valueToBeCalculated * percentage) / 100;
			if (amountTheyCanInvest > limitOfAnYear) {
				amountTheyCanInvest = limitOfAnYear;
			}
		} else {
			percentage = 5;
			amountTheyCanInvest = (valueToBeCalculated * percentage) / 100;
			if (amountTheyCanInvest <= 2200) {
				amountTheyCanInvest = 2200;
			}
		}

		amountTheyCanInvest -= externalAmount;
		if (amountTheyCanInvest < 0) {
			amountTheyCanInvest = 0;
		}
		console.log(amountTheyCanInvest);
		setCalculator(amountTheyCanInvest);
	}

	/***
	 * tommorrows focus
	 * add formula
	 * check its corectly done
	 * also set values for calcuated amt
	 * also check the previous values entered
	 ***/
	// const [checked, setChecked] = React.useState('');
	// function handleChange(event) {
	//   setChecked(event.target.checked);
	// }
	// const [checked1, setChecked1] = React.useState('');
	// function handleChange1(event) {
	//   setChecked1(event.target.checked);
	// }

	const validationSchema = Yup.object().shape({
		spvName: Yup.string().required("SPV name is required"),
		spvCountry: Yup.string().required("SPV country is required"),
		peoples: Yup.array().of(
			Yup.object().shape({
				name: Yup.string().min(4).required("Name is required"),
				email: Yup.string().email().required("email is required"),
			})
		),
		companies: Yup.array().of(
			Yup.object().shape({
				companyName: Yup.string().required("Company name is required"),
				email: Yup.string()
					.email()
					.required("Company email is required"),
				companyAddress: Yup.string().required("Company address is required"),
			})
		),
	});

	const formik = useFormik({

		initialValues:
			selected === "Company" &&
			location.state.data?.userType !== "investor"
				? JoinusValidation.initialValuesOrganizationCompany
				: JoinusValidation.initialValuesOrganizationSPV,
		validationSchema:
			selected === "Company" &&
			location.state.data?.userType !== "investor"
				? JoinusValidation.organizationCompanySchema
				: JoinusValidation.organizationSPVSchema,
		onSubmit: async (values) => {


			console.log("YOO");
			console.log(
				"onSubmit",
				JSON.stringify(
					{
						organizationDetails: { ...values, type: selected },
						data: location.state.data,
					},
					null,
					2
				)
			);
			navigator("/auth/about-your-work", {
				state: {
					organizationDetails: {
						type: selected,
						...values,
					},
					data: location.state.data,
				},
			});

			/*      const { email,
                          password,
                          name,
                          type = values.userType,
                          country,
                          companyName,
                          companyAddress,
                          dob  } = values;*/

			/* try {
                     setLoading(true)
                     await registerWithEmail(email, password);
                     const user = firebase.auth().currentUser;
                     await user.updateProfile({displayName: name});
                     const usersRef = firebase.firestore().collection('users');
                     // window.localStorage.setItem('user', JSON.stringify(user))
                     setUser(user);
                     setProfile({
                       ...user,
                       name,
                       type,
                       userType: location.state.selected,
                       country
                     });
                     await usersRef.add(
                       {
                         email,
                         name,
                         uid: user.uid,
                         type,
                         userType: location.state.selected,
                         country,
                         companyName,
                         companyAddress,
                         dob,
                         createdAt: firebase.firestore.FieldValue.serverTimestamp(),
                       }
                     );
                     setLoading(false)
                     if (location.state.selected === 'creator') {
                       navigator('/creator/add-project');
                     } else {
                       navigator('/investor/membership-plan')
                     }
                   } catch (e) {
                     setLoading(false)
                     alert(JSON.stringify(e, null, 2));
                   }*/
		},
	});

	if (loading) return <Spinner />;
	console.log(formik.values)
	return (
		<>
		<ScrollToTop/>
			<GlobalStyles
				styles={{ ul: { margin: 0, padding: 0, listStyle: "none" } }}
			/>
			{/* Hero unit */}
			{/*<TopBar/>*/}
			{/* <Container  maxWidth="lg" component="main" sx={{ pt: 4, }}>
        <Typography variant="h3" align="center" color="text.primary" component="p">
          Logo
        </Typography>
      </Container>*/}
			<Stepper stepNumber={3} />

			<Container maxWidth="md" component="main" sx={{}}>
				<Box sx={{ pl: 10, pr: 10 }}>
					<Typography
						variant="h4"
						align="left"
						color="text.primary"
						component="p">
						Additional details
						{/*{location.state.data?.userType}*/}
						{/*{messages?.joinNow?.create_new_account?.pageTitle}*/}
					</Typography>
					<Typography
						variant="body"
						align="left"
						color="text.primary"
						component="p"
						sx={{ margin: "20px 0px 40px 0px" }}>
						Who are you? We’d like to know you better.
						{/*{messages?.joinNow?.create_new_account?.titleA}<br/>{messages?.joinNow?.create_new_account?.titleB}<Button variant="text" sx={{textDecoration: 'underline', fontWeight: 600, top: -2}}>{messages?.joinNow?.create_new_account?.signinButton}</Button>.*/}
					</Typography>
				</Box>
			</Container>
			<Container
				alignItems={"center"}
				justifyContent={"center"}
				maxWidth="md"
				component="main"
				sx={{ mb: 5 }}>
				<Grid
					container
					spacing={5}
					alignItems="center"
					justifyContent={"center"}
					sx={{ pl: 10, pr: 10 }}>
					<Grid item xs={12} sm={6} md={4}>
						<Paper elevation={4}>
							<Box
								sx={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									flexDirection: "column",
									mb: 2,
									pb: 1,
									height: 75,
									backgroundColor: `${
										selected !== "Individual"
											? "#ffffff"
											: "#204488"
									}`,
									borderRadius: "10px",
								}}
								onClick={(e) => {
									setSelected("Individual");
									if ((e.target.value = "Individual")) {
										setCalculator(0);
										settotalNetWorth("");
										settotalAnualIncome("");
										setExternal("");
									}
								}}>
								<div
									style={{
										width: "90%",
										textAlign: "right",
										color: `${
											selected === "Individual"
												? "#ffffff"
												: "#204488"
										}`,
										position: "relative",
										top: 12,
									}}>
								</div>
								<Typography
									variant="body1"
									component="p"
									color={
										selected === "Individual"
											? "#ffffff"
											: "#204488"
									}>
									Individual
								</Typography>
								{/*`${tier.id !== selected ? '#ffffff': '#204488' }`*/}
							</Box>
						</Paper>
					</Grid>
					<Grid item xs={12} sm={6} md={4}>
						<Paper elevation={4}>
							<Box
								sx={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									flexDirection: "column",
									mb: 2,
									pb: 1,
									height: 75,
									backgroundColor: `${
										selected !== "Company"
											? "#ffffff"
											: "#204488"
									}`,
									borderRadius: "10px",
								}}
								onClick={(e) => {
									setSelected("Company");
									if ((e.target.value = "Company")) {
										setCalculator(0);
										setCompanyAssets("");
										setExternal("");
									}
								}}>
								<div
									style={{
										width: "90%",
										textAlign: "right",
										color: `${
											selected === "Company"
												? "#ffffff"
												: "#204488"
										}`,
										position: "relative",
										top: 12,
									}}>
										                        {/* <Tooltip title={'tier.text'}  >
                                                <IconButton>
                
									<HelpOutlineIcon style={{ fontSize: 20 }} />
									</IconButton>
                                        </Tooltip> */}

								</div>
								<Typography
									variant="body1"
									component="p"
									color={
										selected === "Company"
											? "#ffffff"
											: "#204488"
									}>
									Company




								</Typography>
								{/*`${tier.id !== selected ? '#ffffff': '#204488' }`*/}
							</Box>
						</Paper>
					</Grid>
					{location.state.data?.userType === "creator" && (
						<Grid item xs={12} sm={6} md={4}>
							<Paper elevation={4}>
								<Box
									sx={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										flexDirection: "column",
										mb: 2,
										pb: 1,
										height: 75,
										backgroundColor: `${
											selected !== "SPV"
												? "#ffffff"
												: "#204488"
										}`,
										borderRadius: "10px",
									}}
									onClick={() => setSelected("SPV")}>
									<Typography
										variant="body1"
										component="p"
										color={
											selected === "SPV"
												? "#ffffff"
												: "#204488"
										}>
										SPV
									</Typography>
									{/*`${tier.id !== selected ? '#ffffff': '#204488' }`*/}
								</Box>
							</Paper>
						</Grid>
					)}
				</Grid>
			</Container>
			{/* // adding for user type is equal to investor */}
			{location.state.data?.userType === "investor" &&
				selected === "Individual" && (
					<Grid item xs={12}>
						<Container maxWidth={"sm"}>
							<Grid container>
								<Grid item xs={12}>
									<Typography
										textAlign={"left"}
										fontWeight={400}
										fontSize={"16px"}
										sx={{ ml: -9 }}>
										Are you an accredited investor?{" "}
										<Tooltip
										 componentsProps={{
											tooltip: {
												color: '#363636',
											  sx: {
												color: '#204488',
												maxWidth: "750px",
												  bgcolor: '#E3E8F0',
												'& .MuiTooltip-arrow': {
												  color: '#E3E8F0',
												},
											  },
											},
										  }} title={
          <div style={{fontSize: "16px"}} >
            The regulations for accredited investors vary from one jurisdiction
            to the other and are often defined by a local market regulator or a
            competent authority. In the U.S, the definition of an accredited
            investor is put forth by SEC in Rule 501 of Regulation D.2
            <br />
            <br />
            To be an accredited investor, a person must have an annual income
            exceeding $200,000 ($300,000 for joint income) for the last two
            years with the expectation of earning the same or a higher income in
            the current year. An individual must have earned income above the
            thresholds either alone or with a spouse over the last two years.
            The income test cannot be satisfied by showing one year of an
            individual's income and the next two years of joint income with a
            spouse.2 A person is also considered an accredited investor if they
            have a net worth exceeding $1 million, either individually or
            jointly with their spouse. The SEC also considers a person to be an
            accredited investor if they are a general partner, executive
            officer, or director for the company that is issuing the
            unregistered securities.2
            <br />
            <br />
            An entity is considered an accredited investor if it is a private
            business development company or an organization with assets
            exceeding $5 million. Also, if an entity consists of equity owners
            who are accredited investors, the entity itself is an accredited
            investor. However, an organization cannot be formed with the sole
            purpose of purchasing specific securities.
          </div>
        } arrow sx={{width:"30px"}} placement="bottom-start">
                    <IconButton>
												<HelpOutlineIcon style={{ fontSize: 20 }} />
										</IconButton>
                  	</Tooltip>
									</Typography>
								</Grid>
								<Grid
									item
									xs={12}
									sx={{
										alignItems: "start",
										justifyContent: "start",
										ml: -19,
										mt: 2,
									}}>
									<Checkbox
										label="I can confirm that I am an accredited investor."
										name="I can confirm that I am an accredited investor."
										checked={checkA}
										onChange={(e) => {
											setCheckA(e.target.checked);
											setCheckB(!e.target.checked);
										}}
									/>
									I can confirm that I am an accredited
									investor.
								</Grid>
								<Grid
									item
									xs={12}
									sx={{
										alignItems: "start",
										justifyContent: "start",
										mr: 30 ,
										ml: -22.5,
										mt: 2,
									}}>
									<Checkbox
										label="I am not an accredited investor."
										name="I am not an accredited investor."
										checked={checkB}
										onChange={(e) => {
											setCheckB(e.target.checked);
											setCheckA(!e.target.checked);
											if (e.target.checked === true) {
												setExternal(0);
												settotalNetWorth(0);
												settotalAnualIncome(0);
												setCalculator(0);
											}
										}}
									/>
									I am not an accredited investor.
								</Grid>
							</Grid>
						</Container>
					</Grid>
				)}

			{/* Adding options when checkbox=== true or value changes  individual card investor side */}

			<Container
				alignItems="start"
				justifyContent="start"
				maxWidth="md"
				component="main"
				sx={{}}>
				{location.state.data?.userType === "investor" &&
					selected === "Individual" &&
					checkA === true && (
						<Container
							maxWidth="md"
							alignItems="start"
							justifyContent="start">
							<Typography
								textAlign="start"
								sx={{
									alignItems: "start",
									justifyContent: "start",
									ml: 6.5,
									mt: 2,
								}} color={colorChange === 'error' && 'error'}>
								How are you an accredited investor?
							</Typography>
							<Grid
								item
								xs={12}
								sx={{
									alignItems: "start",
									justifyContent: "start",
									ml: -25.5,
									mt: 2,
								}}>
								<Checkbox
									label="Individual with net-worth of $1M+ (with or without spouse)"
									name="Individual with net-worth of $1M+ (with or without spouse)"
									checked={checkD}
									onChange={(e) => {
										setCheckD(e.target.checked);
										setCheckE(false);
										setCheckF(false);
										setColor('')
									}}
								/>
								Individual with net-worth of $1M+ (with or
								without spouse)
							</Grid>
							<Grid
								item
								xs={12}
								sx={{
									alignItems: "start",
									justifyContent: "start",
									ml: -8.5,
									mt: 2,
								}}>
								<Checkbox
									label="Individual with annual income in last two years of $200k+ ($300k + spouse)"
									name="Individual with annual income in last two years of $200k+ ($300k + spouse)"
									checked={checkE}
									onChange={(e) => {
										setCheckE(e.target.checked);
										setCheckD(false);
										setCheckF(false);
										setColor('')

									}}
								/>
								Individual with annual income in last two years
								of $200k+ ($300k + spouse)
							</Grid>
							<Grid
								item
								xs={12}
								sx={{
									alignItems: "start",
									justifyContent: "start",
									ml: -17.5,
									mt: 2,
								}}>
								<Checkbox
									label="FINRA-licensed individual in good standing with series 7, 65 or 82"
									name="FINRA-licensed individual in good standing with series 7, 65 or 82"
									checked={checkF}
									onChange={(e) => {
										setCheckF(e.target.checked);
										setCheckD(false);
										setCheckE(false);
										setColor('')

									}}
								/>
								FINRA-licensed individual in good standing with
								series 7, 65 or 82
							</Grid>
						</Container>
					)}
				{selected === "Individual" && checkB === true && (
					<Container
						maxWidth="md"
						alignItems="start"
						justifyContent="start">
						<Typography
							textAlign="start"
							sx={{
								marginLeft: "15%",
								fontWeight: "400",
								fontSize: "16px",
								alignItems: "start",
								justifyContent: "start",
								ml: 6.75 ,
								mt: 2
							}}>In order for you to invest, we will need some
							financial details :
						</Typography>
						<Stack
							direction="row"
							spacing={2}
							sx={{
								display: "flex",
								alignItems: "start",
								justifyContent: "start",
								mt: 5,

								ml: 8,
							}}>
							<Grid item xs={12}>
								<TextField
									sx={{
										width: "397px", ml: -1.5
									}}
									name="Joint yearly income"
									label="Joint yearly income"
									variant="outlined"
									value={totalAnualIncome}
									onChange={(e) =>
										settotalAnualIncome(e.target.value)
									}
								/>
							</Grid>
							<Grid item xs={12}>
								<TextField
									sx={{
										width: "397px",
									}}
									name="Joint net worth"
									label="Joint net worth"
									variant="outlined"
									value={totalNetWorth}
									onChange={(e) =>
										settotalNetWorth(e.target.value)
									}
								/>
							</Grid>
						</Stack>

						<Grid
							item
							xs={12}
							sx={{
								alignItems: "start",
								justifyContent: "start",
								mt: 5,

								ml: -28,
							}}>
							<Checkbox
								label="The above includes my spouse’s income and net worth"
								name="The above includes my spouse’s income and net worth"
								checked={checkG}
								onChange={(e) => {
									setCheckG(e.target.checked);
								}}
							/>
							The above includes my spouse’s income and net worth
						</Grid>

						<Grid
							item
							xs={12}
							sx={{
								lignItems: "start",
								justifyContent: "start",
								ml: -18,
								mt: 2,
							}}>
							<Checkbox
								label="FINRA-licensed individual in good standing with series 7, 65 or 82"
								name="FINRA-licensed individual in good standing with series 7, 65 or 82"
								checked={checkH}
								onChange={(e) => {
									setCheckH(e.target.checked);
									if (e.target.checked === false) {
										setExternal(0);
									}
								}}
							/>
							We have invested in crowdfunding offerings in the
							last 12 months
						</Grid>
						{checkH === true && (
							<Container>
								<Grid
									item
									xs={12}
									sx={{
										display: "flex",
										alignItems: "start",
										justifyContent: "start",

										ml: 3.5,
									}}>
									{" "}
									<TextField
										name="External Reg CF investments ($)."
										label="External Reg CF investments ($)."
										fullWidth={"100%"}
										value={external}
										onChange={(e) => {
											setExternal(e.target.value);
										}}
										sx={{
											alignItems: "start",
											justifyContent: "start",
											mt: 5,
											width: "826px",
										}}
									/>
								</Grid>
							</Container>
						)}

						<Stack
							spacing={4}
							sx={{
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								mt: 3,
								ml: 15,
							}}>
							<Button
								variant="contained"
								sx={{ pt: 1.2, pb: 1.2, pl: 5, pr: 5 }}
								type="submit"
								onClick={update}>
								Update
							</Button>
						</Stack>
						{/*Calaculating amount for investment per year if values are entered in  textfield*/}
						{/*{totalAnualIncome===settotalAnualIncome===true && totalNetWorth===settotalNetWorth===true &&*/}
						{/*    {...update}*/}
						{/*}*/}

						<Grid
							container
							spacing={2}
							sx={{ pl: 10, pr: 10, mt: 6, ml: -3, mb: 3,}}>
							<Paper elevation={4}>
								<Box
									sx={{
										height: "454px",
										width: "826px",
									}}>
									<Grid
										item
										xs={12}
										sx={{
											ml: "3px", borderBottom:
											"1px solid #20448830",
										}}>
										<Typography
											sx={{
												height: "80px",

												width: "826px",
												fontWeight: "600px",
												fontSize: "24px",
												mt: "4px",
												pt: 2,
												pr: 40 ,  ml: 9
											}}>
											Regulation Crowdfunding limit
										</Typography>
									</Grid>

									<Grid item xs={12}>
										<Typography
											textAlign={"left"}
											sx={{
												color: "#204488",
												fontWeight: "400px",
												fontSize: "48px",
												ml: 20,
												mt: 6.5,
											}}>
											${calculator}
										</Typography>
									</Grid>
									<Grid item xs={12}>
										<Typography
											textAlign={"left"}
											sx={{
												color: "#B5B5B5",
												fontWeight: "400px",
												fontSize: "18px",
												ml: 19.5,
											}}>
											Per 12 months
										</Typography>
									</Grid>
									<Grid
										item
										xs={8}
										alignItems="center"
										justifyContent="center"
										sx={{ ml: 19.5 }}>
										<Slider
											aria-label="MinimumInvestment"
											value={((external/calculator)*100)}
											onChange={(e) => {
												if (checkB === false) {
													setCalculator(0);
												}
											}}

										/>
									</Grid>

									<Grid item xs={12}>
										<Typography
											textAlign={"left"}
											sx={{
												color: "#B5B5B5",
												fontWeight: "400px",
												fontSize: "18px",
												ml: 19.5,
											}}>
											${external}
										</Typography>
										<Typography
											textAlign={"left"}
											sx={{
												color: "#B5B5B5",
												fontWeight: "400px",
												fontSize: "18px",
												ml: 19.5,
											}}>
											Invested
										</Typography>
									</Grid>
									<Grid item xs={12}>
										<Typography
											textAlign={"right"}
											sx={{
												color: "#B5B5B5",
												fontWeight: "400px",
												fontSize: "18px",
												ml: 10,
												marginTop: "-6.5%",
												marginRight: "15%",
											}}>
											${calculator}
										</Typography>
										<Typography
											textAlign={"right"}
											sx={{
												color: "#B5B5B5",
												fontWeight: "400px",
												fontSize: "18px",
												ml: 10,
												marginRight: "15%",
											}}>
											Remaining
										</Typography>
									</Grid>
									<Grid
										item
										xs={12}
										sx={{
											mt: 6,
											alignItems: "left",
											justifyContent: "left",
											marginRight: "300px",
										}}>
										<img
											src={"/assets/icon.png"}
											height={"20px"}
											alt="icon"
										/>
									</Grid>
									<Grid item xs={12}>
										<Typography
											sx={{
												color: "#B5B5B5",
												fontWeight: "400px",
												fontSize: "18px",
												ml: 10,
												marginRight: "10%",
												marginTop: "-3.5%",

											}}>
											Invested outside the platform
										</Typography>
									</Grid>
								</Box>
							</Paper>
						</Grid>
					</Container>
				)}
			</Container>
			{/* End hero unit */}
			<Container
				alignItems="center"
				justifyContent="center"
				maxWidth="md"
				component="main"
				sx={{}}>
				<Grid container spacing={2} sx={{ pl: 10, pr: 10 }}>
					<Grid item xs={12}>
						<FormikProvider value={formik}>
							<Box
								component="form"
								onSubmit={formik.handleSubmit}
								sx={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									mb: 2,
									flexDirection: "column",
								}}>
								<Grid container spacing={2}>
									{(location.state.data?.userType ===
										"creator" ||
										location.state.data?.userType ===
											"artist") &&
										selected === "Company" && (
											<>
												<Grid item xs={12}>
													<TextField
														name="companyName"
														label={
															messages?.joinNow
																?.create_new_account
																?.form
																?.companyName
														}
														value={
															formik.values
																.companyName
														}
														onChange={
															formik.handleChange
														}
														error = { !!formik.errors.companyName }
														helperText = { (formik.errors.companyName )}
														// error={
														// 	formik.touched
														// 		.companyName &&
														// 	Boolean(
														// 		formik.errors
														// 			.companyName
														// 	)
														// }
														// helperText={
														// 	formik.touched
														// 		.companyName &&
														// 	formik.errors
														// 		.companyName
														// }
														variant="outlined"
														sx={{ width: "100%" }}
													/>
												</Grid>
												<Grid item xs={12}>
													<TextField
														name="companyAddress"
														label="Company Address"
														variant="outlined"
														sx={{ width: "100%" }}
														onChange={
															formik.handleChange
														}
														error = { !!formik.errors.companyAddress }
														helperText = { (formik.errors.companyAddress )}
														// error={
														// 	formik.touched
														// 		.companyAddress &&
														// 	Boolean(
														// 		formik.errors
														// 			.companyAddress
														// 	)
														// }
														// helperText={
														// 	formik.touched
														// 		.companyAddress &&
														// 	formik.errors
														// 		.companyAddress
														// }
													/>
												</Grid>
												{/* <Grid item xs={12}>
													<TextField
														name="registrationNumber"
														label="Company Registration Number"
														variant="outlined"
														sx={{ width: "100%" }}
														onChange={
															formik.handleChange
														}
														error={
															formik.touched
																.registrationNumber &&
															Boolean(
																formik.errors
																	.registrationNumber
															)
														}
														helperText={
															formik.touched
																.registrationNumber &&
															formik.errors
																.registrationNumber
																? "Please Enter a valid registration number"
																: ""
														}
													/>
												</Grid> */}
												<Grid item xs={12}>
													<TextField
														name="email"
														label={
															formik.values
																.userType ===
															"Company"
																? messages
																		?.joinNow
																		?.create_new_account
																		?.form
																		?.companyEmail
																: messages
																		?.joinNow
																		?.create_new_account
																		?.form
																		?.companyEmail
														}
														value={
															formik.values.email
														}
														onChange={
															formik.handleChange
														}
														error = { !!formik.errors.email }
														helperText = { (formik.errors.email )}
														// error={
														// 	formik.touched
														// 		.email &&
														// 	Boolean(
														// 		formik.errors
														// 			.email
														// 	)
														// }
														// helperText={
														// 	formik.touched
														// 		.email &&
														// 	formik.errors.email
														// 		? "Please Enter a valid email"
														// 		: ""
														// }
														variant="outlined"
														sx={{ width: "100%" }}
														type="email"
													/>
												</Grid>

												<Grid item xs={12}>
													<TextField
														controlled={"true"}
														select
														// defaultValue = "Sole proprietorship"
														name="companyType"
														label={"Company Type"}
														value={
															formik.values
																.companyType
														}
														onChange={
															formik.handleChange
														}
														error = { !!formik.errors.companyType }
														helperText = { (formik.errors.companyType )}
														// error={
														// 	formik.touched
														// 		.companyType &&
														// 	Boolean(
														// 		formik.errors
														// 			.companyType
														// 	)
														// }

														// helperText={
														// 	formik.touched
														// 		.companyType &&
														// 	formik.errors
														// 		.companyType
														// }

														variant="outlined"
														fullWidth={"100%"}
														sx={{
															width: "100%",
															alignItems:
																"flex-start",
															justifyContent:
																"flex-start",
															textAlign : "left"
														}}>
														<MenuItem
															value={
																"Sole proprietorship"
															}>
															Sole proprietorship
														</MenuItem>
														<MenuItem
															value={
																"Partnership"
															}>
															Partnership
														</MenuItem>
														<MenuItem value={"LLP"}>
															LLP
														</MenuItem>
														<MenuItem
															value={
																"Series LLC"
															}>
															Series LLC
														</MenuItem>
														<MenuItem
															value={
																"C corporation"
															}>
															C corporation
														</MenuItem>
														<MenuItem
															value={
																"S corporation"
															}>
															S corporation
														</MenuItem>
														<MenuItem
															value={
																"Nonprofit corporation"
															}>
															Nonprofit
															corporation
														</MenuItem>
														<MenuItem
															value={
																"Benefit corporation"
															}>
															Benefit corporation
														</MenuItem>
														<MenuItem value={"L3C"}>
															L3C
														</MenuItem>
													</TextField>
												</Grid>
											</>
										)}

									{location.state.data?.userType ===
										"investor" &&
										selected === "Company" && (
											<Box
												onSubmit={formik.handleSubmit}
												maxWidth={"lg"}
												sx={{
													alignItems: "start",
													justifyContent: "start",

												}}
												direction={"column"}>
												<Grid item xs={12}>

													<Typography
														textAlign={"start"}
														fontWeight={400}
														sx={{
															ml: 2,
															mb: 2.5


														}}
														>
														About Your Company{" "}
															<Tooltip
															componentsProps={{
																tooltip: {
																	color: '#363636',
																  sx: {
																	fontSize: 16 ,
																	color: '#204488',
																	maxWidth: "296px",
																	  bgcolor: '#E3E8F0',
																	'& .MuiTooltip-arrow': {
																	  color: '#E3E8F0',
																	},
																  },
																},
															  }}title={'This information is required under the Crowdfunding regulation rules.'} arrow sx={{width:"30px"}} placement="bottom-start">
															<IconButton>
																	<HelpOutlineIcon style={{ fontSize: 20 }} />
															</IconButton>
															</Tooltip>

													</Typography>
												</Grid>
												<Box
													item
													xs={12}
													sx={{ mb: 2.5,}}>
													<Stack >
													<Stack direction="row" sx={{ml:.8}}>
													<Checkbox
														label="Entity with all accredited investors"
														checked={checka}
														onChange={(e) => {
															setChecka(
																e.target.checked
															);
															setCheckb(false);
															setCheckc(false);
														}}
														name="Entity with all accredited investors"
													/>
													<Typography sx={{mt:1}}>Entity with all accredited investors.</Typography>
													</Stack>
													<Stack direction="row" sx={{ml:.8}}>
													<Checkbox

														label="My company assets are equal or higher than $5M."
														checked={checkb}
														onChange={(e) => {
															setChecka(false);
															setCheckb(
																e.target.checked
															);
															setCheckc(false);
														}}
														name="My company assets are equal or higher than $5M."
													/>
													<Typography sx={{mt:1}}>My company assets are equal
													or higher than $5M.</Typography>
													</Stack>
													<Stack direction="row" sx={{ml:.8
													}}>
													<Checkbox
														label="My company assets are lower than $5M."
														checked={checkc}
														onChange={(e) => {
															setCheckc(
																e.target.checked
															);
															if (
																e.target
																	.checked ===
																true
															) {
																setExternal("");
																setCompanyAssets(
																	""
																);
																setCalculator(
																	0
																);
															}
															setCheckb(false);
															setChecka(false);
														}}
														name="My company assets are lower than $5M."
													/>
													<Typography sx={{mt:1}}>My company assets are lower
													than $5M.</Typography>
													</Stack>
													</Stack>
												</Box>




											</Box>
										)}

									{/* adding option for company card  investor when check box is changwed                     */}
									{selected === "Company" && checkc === true && (
										<Container
											maxWidth="md"
											alignItems="start"
											justifyContent="start">
											<Grid item xs={12} sx={{  ml: -1.5, mb: 5, mt: 5 }}>
												<TextField
													name="Your company assets"
													label="Your company assets"
													fullWidth="100%"
													onInput={(e) => {
														setCompanyAssets(
															e.target.value
														);
													}}
													value={companyAssets}
												/>
											</Grid>
											<Grid item xs={12} sx={{  ml: -8 , mb: 5, mt: 5 }}>
												<Checkbox
													name="We have invested in crowdfunding offerings in the last 12 months "
													label="We have invested in crowdfunding offerings in the last 12 months "
													checked={checkd}
													onChange={(e) => {
														setCheckd(
															e.target.checked
														);
														if (checkd === false) {
															setExternal("");
														}
													}}
												/>
												We have invested in crowdfunding
												offerings in the last 12 months
												{selected === "Company" &&
													checkd === true && (
														<Grid item xs={12}  sx={{  ml: 6.5, mb: 3, mt: 5 }}>
															<TextField
																name="External Reg CF investments ($)."
																label="External Reg CF investments ($)."
																fullWidth="100%"
																value={external}
																onChange={(e) =>
																	setExternal(
																		e.target
																			.value
																	)
																}
															/>
														</Grid>
													)}
											</Grid>
											<Stack
												spacing={4}
												sx={{
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
													mt: 2,
												}}>
												<Button
													variant="contained"
													sx={{
														pt: 1.2,
														pb: 1.2,
														pl: 5,
														pr: 5,
														mt: 2,
														ml: 2
													}}
													type="submit"
													onClick={update1}
													disabled={!companyAssets}>
													Update
												</Button>
											</Stack>

											<Grid
												container
												spacing={2}
												sx={{ mt: 10, ml: -1.5 }}>
												<Paper elevation={4}>
													<Box
														 sx={{

															height: "454px",
															width: "826px",

														}}>
														<Grid item xs={12} sx={{borderBottom:
													"1px solid #20448830",}} >
															<Typography
																sx={{
																	height: "80px",

																	width: "826px",
																	fontWeight: "600px",
																	fontSize: "24px",
																	mt: "3px",
																	pt: 2,pr: 40,  ml: 9
																}}>
																Regulation
																Crowdfunding
																limit
															</Typography>
														</Grid>
														<Grid item xs={12}>
															<Typography
																textAlign={
																	"left"
																}
																sx={{
																	color: "#204488",
																	fontWeight:
																		"400px",
																	fontSize:
																		"48px",
																	ml: 20,
																	mt: 6.5,
																}}>
																${calculator}
															</Typography>
														</Grid>
														<Grid item xs={12}>
															<Typography
																textAlign={
																	"left"
																}
																sx={{
																	color: "#B5B5B5",
																	fontWeight:
																		"400px",
																	fontSize:
																		"18px",
																	ml: 19.5,
																}}>
																Per 12 months
															</Typography>
														</Grid>
														<Grid
															item
															xs={8}
															alignItems="center"
															justifyContent="center"
															sx={{ ml: 19.5, }}>
															<Slider
																aria-label="MinimumInvestment"

																	value={((external/calculator)*100)}

																onChange={(
																	e
																) => {
																	if (
																		checkc ===
																		false
																	) {
																		setCalculator(
																			0
																		);
																	}
																}}
															/>
														</Grid>
														<Grid item xs={12}>
															<Typography
																textAlign={
																	"left"
																}
																sx={{
																	color: "#B5B5B5",
																	fontWeight:
																		"400px",
																	fontSize:
																		"18px",
																		ml: 19.5,
																}}>
																${external}
															</Typography>
															<Typography
																textAlign={
																	"left"
																}
																sx={{
																	color: "#B5B5B5",
																	fontWeight:
																		"400px",
																	fontSize:
																		"18px",
																		ml: 19.5
																}}>
																Invested
															</Typography>
														</Grid>
														<Grid item xs={12}>
															<Typography
																textAlign={
																	"right"
																}
																sx={{
																	color: "#B5B5B5",
																	fontWeight:
																		"400px",
																	fontSize:
																		"18px",
																	ml: 10,
																	marginTop:
																		"-6.5%",
																	marginRight:
																		"15%",
																}}>
																${calculator}
															</Typography>
															<Typography
																textAlign={
																	"right"
																}
																sx={{
																	color: "#B5B5B5",
																	fontWeight:
																		"400px",
																	fontSize:
																		"18px",

																	marginRight:
																		"15%",
																}}>
																Remaining
															</Typography>
														</Grid>
														<Grid
															item
															xs={12}
															sx={{
																mt: 6,
																alignItems:
																	"left",
																justifyContent:
																	"left",
																marginRight:
																	"300px",
															}}>
															<img
																src={
																	"/assets/icon.png"
																}
																height={"20px"}
																alt="icon"
															/>
														</Grid>
														<Grid item xs={12}>
															<Typography
																sx={{
																	color: "#B5B5B5",
																	fontWeight:
																		"400px",
																	fontSize:
																		"18px",
																	ml: 10,
																	marginRight:
																		"10%",
																	marginTop:
																		"-3.5%",
																}}>
																invested outside
																the platform
															</Typography>
														</Grid>
													</Box>
												</Paper>
											</Grid>
										</Container>
									)}

									{/* {selected ==='Individual' &&
                           <>
                            <Typography variant=" body1" fontWeight={400} fontSize={"16px"} textAlign="center" sx={{marginLeft:"23%" }}>
                            Are you an accredited investor? &nbsp;<IconButton><HelpOutlineIcon style={{fontSize:25,color:"#204488"}}/></IconButton>
                            </Typography>
                          <Grid item xs={12} direction={"row"} spacing={2}>
                          <Checkbox
                          checked={checked}
                          onChange={handleChange}
                          inputProps={{ 'aria-label': 'controlled' }}
                          />
                          I can confirm that I am an accredited investor.
                      </Grid>
                        <Grid item xs={12} direction={"row"} spacing={2}>
                          <Checkbox
                          checked={checked1}
                          onChange={handleChange1}
                          inputProps={{ 'aria-label': 'controlled' }}
                          sx={{marginLeft:"-17%"}}
                          />
                            I am not an accredited investor.
                          </Grid>
                         </>
                   } */}

									{selected === "SPV" && (
										<>
										<Typography
												variant={"h4"}
												my={5}
												mx={2}
												mb={2}>
												Set up SPV for project
											</Typography>
											<Grid item xs={12}>

												<TextField
													name="spvName"
													label="SPV Name"
													value={
														formik.values.spvName
													}
													onChange={
														formik.handleChange
													}
													error={
														formik.touched
															.spvName &&
														Boolean(
															formik.errors
																.spvName
														)
													}
													helperText={
														formik.touched
															.spvName &&
														formik.errors.spvName
													}
													variant="outlined"
													sx={{ width: "100%" }}
												/>
											</Grid>
											<Grid item xs={12}>
												<TextField
													name="spvCountry"
													label="SPV Country"
													value={
														formik.values.spvCountry
													}
													onChange={
														formik.handleChange
													}
													error={
														formik.touched
															.spvCountry &&
														Boolean(
															formik.errors
																.spvCountry
														)
													}
													helperText={
														formik.touched
															.spvCountry &&
														formik.errors.spvCountry
													}
													variant="outlined"
													sx={{ width: "100%" }}
												/>
											</Grid>
											<Typography
												variant={"h4"}
												my={5}
												mx={2}
												mb={2}>
												SPV Members - Add people
											</Typography>
											<Grid item xs={12}>
												<FieldArray
													name={"peoples"}
													render={(arrayHelpers) => {
														return (
															<>
																{arrayHelpers?.form.values.peoples.map(
																	(p, i) => (
																		<Box
																			key={
																				i +
																				"people"
																			}
																			sx={{
																				mb: 5,
																			}}>
																			{arrayHelpers
																				?.form
																				.values
																				.peoples
																				.length >
																				1 && (
																				<Button
																					variant={
																						"outlined"
																					}
																					color={
																						"error"
																					}
																					startIcon={
																						<CloseIcon />
																					}
																					onClick={() =>
																						arrayHelpers.remove(
																							i
																						)
																					}
																					sx={{
																						float: "right",
																					}}>
																					Remove
																				</Button>
																			)}
																			<Grid
																				container
																				spacing={
																					3
																				}>
																				<Grid
																					item
																					xs={
																						12
																					}>
																					<TextField
																						name={`peoples.${i}.name`}
																						label="Name"
																						value={
																							formik
																								.values
																								.peoples[
																								i
																							]
																								.name
																						}
																						onChange={
																							formik.handleChange
																						}
																						error={
																							formik.touched &&
																							formik
																								.touched
																								.peoples !==
																								undefined &&
																							formik
																								.errors
																								.peoples !==
																								undefined &&
																							formik
																								.touched
																								.peoples[
																								i
																							]
																								.name &&
																							Boolean(
																								formik
																									.errors
																									.peoples[
																									i
																								]
																									.name
																							)
																						}
																						helperText={
																							formik.touched &&
																							formik
																								.touched
																								.peoples !==
																								undefined &&
																							formik
																								.errors
																								.peoples !==
																								undefined &&
																							formik
																								.touched
																								.peoples[
																								i
																							]
																								.name &&
																							formik
																								.errors
																								.peoples[
																								i
																							]
																								.name
																						}
																						variant="outlined"
																						sx={{
																							width: "100%",
																						}}
																					/>
																				</Grid>

																				<Grid
																					item
																					xs={
																						12
																					}>
																					<TextField
																						name={`peoples.${i}.email`}
																						label="Email"
																						value={
																							formik
																								.values
																								.peoples[
																								i
																							]
																								.email
																						}
																						onChange={
																							formik.handleChange
																						}
																						error={
																							formik.touched &&
																							formik
																								.touched
																								.peoples !==
																								undefined &&
																							formik
																								.errors
																								.peoples !==
																								undefined &&
																							formik
																								.touched
																								.peoples[
																								i
																							]
																								.email &&
																							Boolean(
																								formik
																									.errors
																									.peoples[
																									i
																								]
																									.email
																							)
																						}
																						helperText={
																							(formik.touched &&
																							formik
																								.touched
																								.peoples !==
																								undefined &&
																							formik
																								.errors
																								.peoples !==
																								undefined &&
																							formik
																								.touched
																								.peoples[
																								i
																							]
																								.email &&
																							formik
																								.errors
																								.peoples[
																								i
																							]
																								.email)? "Please enter a valid email" : ""
																						}
																						variant="outlined"
																						sx={{
																							width: "100%",
																						}}
																					/>
																				</Grid>
																				<Grid
																					item
																					xs={
																						12
																					}>
																					<TextField
																						name={`peoples.${i}.phonenumber`}
																						label="Phone number"
																						value={
																							formik
																								.values
																								.peoples[
																								i
																							]
																								.phonenumber
																						}
																						onChange={
																							formik.handleChange
																						}
																						error={
																							formik.touched &&
																							formik
																								.touched
																								.peoples !==
																								undefined &&
																							formik
																								.errors
																								.peoples !==
																								undefined &&
																							formik
																								.touched
																								.peoples[
																								i
																							]
																								.phonenumber &&
																							Boolean(
																								formik
																									.errors
																									.peoples[
																									i
																								]
																									.phonenumber
																							)
																						}
																						helperText={
																							formik.touched &&
																							formik
																								.touched
																								.peoples !==
																								undefined &&
																							formik
																								.errors
																								.peoples !==
																								undefined &&
																							formik
																								.touched
																								.peoples[
																								i
																							]
																								.phonenumber &&
																							formik
																								.errors
																								.peoples[
																								i
																							]
																								.phonenumber
																						}
																						variant="outlined"
																						sx={{
																							width: "100%",
																						}}
																					/>
																				</Grid>
																				<Grid
																					item
																					xs={
																						12
																					}>
																					<TextField
																						name={`peoples.${i}.role`}
																						label="Role"
																						value={
																							formik
																								.values
																								.peoples[
																								i
																							]
																								.role
																						}
																						onChange={
																							formik.handleChange
																						}
																						error={
																							formik.touched &&
																							formik
																								.touched
																								.peoples !==
																								undefined &&
																							formik
																								.errors
																								.peoples !==
																								undefined &&
																							formik
																								.touched
																								.peoples[
																								i
																							]
																								.role &&
																							Boolean(
																								formik
																									.errors
																									.peoples[
																									i
																								]
																									.role
																							)
																						}
																						helperText={
																							formik.touched &&
																							formik
																								.touched
																								.peoples !==
																								undefined &&
																							formik
																								.errors
																								.peoples !==
																								undefined &&
																							formik
																								.touched
																								.peoples[
																								i
																							]
																								.role &&
																							formik
																								.errors
																								.peoples[
																								i
																							]
																								.role
																						}
																						variant="outlined"
																						sx={{
																							width: "100%",
																						}}
																					/>
																				</Grid>

																				<Grid
																					item
																					sx={
																						12
																					}>
																					{[
																						...arrayHelpers
																							?.form
																							.values
																							.peoples,
																					].pop()
																						.id ===
																						p.id && (
																						<Button
																							variant={
																								"outlined"
																							}
																							startIcon={
																								<AddIcon />
																							}
																							onClick={() =>
																								arrayHelpers.push(
																									{
																										id: Math.random(),
																										name: "",
																										email: "",
																									}
																								)
																							}>
																							Add
																							another
																						</Button>
																					)}
																				</Grid>
																			</Grid>
																		</Box>
																	)
																)}
															</>
														);
													}}
												/>
											</Grid>
											<Typography
												variant={"h4"}
												my={5}
												mx={2}
												mb={2}>
												SPV Members - Add Company
											</Typography>
											<Grid item xs={12}>
												<FieldArray
													name={"companies"}
													render={(arrayHelpers) => {
														return (
															<>
																{arrayHelpers?.form.values.companies.map(
																	(p, i) => (
																		<Box
																			key={
																				i +
																				"company"
																			}
																			sx={{
																				mb: 5,
																			}}>
																			{arrayHelpers
																				?.form
																				.values
																				.companies
																				.length >
																				1 && (
																				<Button
																					variant={
																						"outlined"
																					}
																					color={
																						"error"
																					}
																					startIcon={
																						<CloseIcon />
																					}
																					onClick={() =>
																						arrayHelpers.remove(
																							i
																						)
																					}
																					sx={{
																						float: "right",
																					}}>
																					Remove
																				</Button>
																			)}
																			<Grid
																				container
																				spacing={
																					3
																				}>
																				<Grid
																					item
																					xs={
																						12
																					}>
																					<TextField
																						// name={`companies.${i}.companyName`}
																						label="Name of representative"
																						// value={formik.values.companies[i].companyName}
																						// onChange={formik.handleChange}
																						// error={(formik.touched && formik.touched.companies !== undefined &&  formik.errors.companies !== undefined) && formik.touched.companies[i].companyName && Boolean(formik.errors.companies[i].companyName)}
																						// helperText={(formik.touched && formik.touched.companies !== undefined &&  formik.errors.companies !== undefined) && formik.touched.companies[i].companyName&& formik.errors.companies[i].companyName}
																						variant="outlined"
																						sx={{
																							width: "100%",
																						}}
																					/>
																				</Grid>
																				<Grid
																					item
																					xs={
																						12
																					}>
																					<TextField
																						// name={`companies.${i}.companyName`}
																						label="Role of representative"
																						// value={formik.values.companies[i].companyName}
																						// onChange={formik.handleChange}
																						// error={(formik.touched && formik.touched.companies !== undefined &&  formik.errors.companies !== undefined) && formik.touched.companies[i].companyName && Boolean(formik.errors.companies[i].companyName)}
																						// helperText={(formik.touched && formik.touched.companies !== undefined &&  formik.errors.companies !== undefined) && formik.touched.companies[i].companyName&& formik.errors.companies[i].companyName}
																						variant="outlined"
																						sx={{
																							width: "100%",
																						}}
																					/>
																				</Grid>
																				<Grid
																					item
																					xs={
																						12
																					}>
																					<TextField
																						// name={`companies.${i}.companyName`}
																						label="Phone number of representative"
																						// value={formik.values.companies[i].companyName}
																						// onChange={formik.handleChange}
																						// error={(formik.touched && formik.touched.companies !== undefined &&  formik.errors.companies !== undefined) && formik.touched.companies[i].companyName && Boolean(formik.errors.companies[i].companyName)}
																						// helperText={(formik.touched && formik.touched.companies !== undefined &&  formik.errors.companies !== undefined) && formik.touched.companies[i].companyName&& formik.errors.companies[i].companyName}
																						variant="outlined"
																						sx={{
																							width: "100%",
																						}}
																					/>
																				</Grid>

																				<Grid
																					item
																					xs={
																						12
																					}>
																					<TextField
																						name={`companies.${i}.companyName`}
																						label="Company name"
																						value={
																							formik
																								.values
																								.companies[
																								i
																							]
																								.companyName
																						}
																						onChange={
																							formik.handleChange
																						}
																						error={
																							formik.touched &&
																							formik
																								.touched
																								.companies !==
																								undefined &&
																							formik
																								.errors
																								.companies !==
																								undefined &&
																							formik
																								.touched
																								.companies[
																								i
																							]
																								.companyName &&
																							Boolean(
																								formik
																									.errors
																									.companies[
																									i
																								]
																									.companyName
																							)
																						}
																						helperText={
																							formik.touched &&
																							formik
																								.touched
																								.companies !==
																								undefined &&
																							formik
																								.errors
																								.companies !==
																								undefined &&
																							formik
																								.touched
																								.companies[
																								i
																							]
																								.companyName &&
																							formik
																								.errors
																								.companies[
																								i
																							]
																								.companyName
																						}
																						variant="outlined"
																						sx={{
																							width: "100%",
																						}}
																					/>
																				</Grid>

																				<Grid
																					item
																					xs={
																						12
																					}>
																					<TextField
																						name={`companies.${i}.email`}
																						label="Company email"
																						value={
																							formik
																								.values
																								.companies[
																								i
																							]
																								.email
																						}
																						onChange={
																							formik.handleChange
																						}
																						error={
																							formik.touched &&
																							formik
																								.touched
																								.companies !==
																								undefined &&
																							formik
																								.errors
																								.companies !==
																								undefined &&
																							formik
																								.touched
																								.companies[
																								i
																							]
																								.email &&
																							Boolean(
																								formik
																									.errors
																									.companies[
																									i
																								]
																									.email
																							)
																						}
																						helperText={
																							(formik.touched &&
																							formik
																								.touched
																								.companies !==
																								undefined &&
																							formik
																								.errors
																								.companies !==
																								undefined &&
																							formik
																								.touched
																								.companies[
																								i
																							]
																								.email &&
																							formik
																								.errors
																								.companies[
																								i
																							]
																								.email)? "Please enter a valid email address" : ""
																						}
																						variant="outlined"
																						sx={{
																							width: "100%",
																						}}
																					/>
																				</Grid>

																				<Grid
																					item
																					xs={
																						12
																					}>
																					<TextField
																						name={`companies.${i}.address`}
																						label="Company address"
																						value={
																							formik
																								.values
																								.companies[
																								i
																							]
																								.address
																						}
																						onChange={
																							formik.handleChange
																						}
																						error={
																							formik.touched &&
																							formik
																								.touched
																								.companies !==
																								undefined &&
																							formik
																								.errors
																								.companies !==
																								undefined &&
																							formik
																								.touched
																								.companies[
																								i
																							]
																								.address &&
																							Boolean(
																								formik
																									.errors
																									.companies[
																									i
																								]
																									.address
																							)
																						}
																						helperText={
																							formik.touched &&
																							formik
																								.touched
																								.companies !==
																								undefined &&
																							formik
																								.errors
																								.companies !==
																								undefined &&
																							formik
																								.touched
																								.companies[
																								i
																							]
																								.address &&
																							formik
																								.errors
																								.companies[
																								i
																							]
																								.address
																						}
																						variant="outlined"
																						sx={{
																							width: "100%",
																						}}
																					/>
																				</Grid>

																				<Grid
																					item
																					sx={
																						12
																					}>
																					{[
																						...arrayHelpers
																							?.form
																							.values
																							.companies,
																					].pop()
																						.id ===
																						p.id && (
																						<Button
																							variant={
																								"outlined"
																							}
																							startIcon={
																								<AddIcon />
																							}
																							onClick={() =>
																								arrayHelpers.push(
																									{
																										id: Math.random(),
																										companyName:
																											"",
																										address:
																											"",
																										email: "",
																									}
																								)
																							}>
																							Add
																							another
																						</Button>
																					)}
																				</Grid>
																			</Grid>
																		</Box>
																	)
																)}
															</>
														);
													}}
												/>
											</Grid>
										</>
									)}
									<Grid item xs={12}>
										<div
											style={{
												width: "100%",
												margin: "auto",
											}}>
											<Typography
												variant="body"
												align="left"
												color="text.primary"
												component="p"
												sx={{ margin: "21px 0px" ,ml: -0.5 }}>
												{
													messages?.joinNow
														?.create_new_account
														?.lastText
												}
												<Button
													variant="text"
													sx={{
														textDecoration:
															"underline",
														fontWeight: 600,
														top: -2,
													}}onClick={()=>navigator('/terms')}>{messages?.joinNow?.create_new_account?.termsOfService}
												</Button>
											</Typography>
											<br></br>
										</div>
									</Grid>
									<Container
										maxWidth="lg"
										component="main"
										sx={{}}>
										<Stack
											spacing={5}
											direction="row"
											sx={{
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
												marginTop:"20px",
                      marginBottom:"20px"
											}}>
											<Button
												variant="outlined"
												sx={{
													pt: 1.2, pb:1.2, pl: 5, pr:5,
													textTransform: "capitalize",
													width:"180px"
												}}
												onClick={() => navigator(-1)}>
												Go back
											</Button>
											{selected === "Individual" ||
											(selected === "Company" &&
												location.state.data
													?.userType ===
													"investor") ? (
												<Button
													variant="contained"
													sx={{
														pt: 1.2, pb:1.2, pl: 5, pr:5,
														textTransform:
															"capitalize",
															width:"180px"
													}}
													onClick={() => {
														if (location.state.data
																?.userType ===
															"investor" && selected === "Individual" && checkA === true && !checkD && !checkE && !checkF) {
															setColor('error')
															return
														}
														navigator(
															"/auth/about-your-work",
															{
																state: {
																	organizationDetails:
																		{
																			type: selected,
																			aboutYourCompany:
																				{
																					accredited:
																						checka
																							? "Yes"
																							: "No",
																					assetsAreEqualFiveM:
																						checkb
																							? "Yes"
																							: "No",
																					assetsAreLowerFiveM:
																						checkc
																							? "Yes"
																							: "No",
																					yourAssetWorth:
																					companyAssets,
																				},
																			crowdFundingLast:
																				selected ===
																				"Individual"
																					? checkd
																						? "Yes"
																						: "No "
																					: checkH
																						? "Yes"
																						: "No",
																			externalCFInvestment:
																			external,
																			regulationCrowdFundingLimit:
																			calculator,
																			includeSpouseIncnomeWorth:
																				checkG
																					? "Yes"
																					: "No",
																			joinNetWorth:
																			totalNetWorth,
																			joinYearlyIncome:
																			totalAnualIncome,
																			iamNotanAccreditedInvestor:
																				checkB
																					? "Yes"
																					: "No",
																			iCanConfirmThatIAmAnAccreditedInvestor:
																				checkA
																					? "Yes"
																					: "No",
																			howAreYouAnAccreditedInvestor:
																				{
																					individualWithNetWorthOfOneMPlus:
																						checkD
																							? "Yes"
																							: "No",
																					IndividualWithAnnualIncomeLastTwoYearsTwoHundardKPlusSpouse:
																						checkE
																							? "Yes"
																							: "No",
																					FINRAlicensed:
																						checkF
																							? "Yes"
																							: "No",
																				},
																		},
																	data: location
																		.state
																		.data,
																},
															}
														)
													}


													}>
													{
														messages?.joinNow
															?.create_new_account
															?.nextButton
													}
												</Button>
											) : (
												<Button
													variant="contained"
													sx={{
														pt: 1.2, pb:1.2, pl: 5, pr:5,
														textTransform:
															"capitalize",
															width:'180px'
													}}
													type="submit">
													{
														messages?.joinNow
															?.create_new_account
															?.nextButton
													}
												</Button>
											)}
										</Stack>
									</Container>
									<Container
										maxWidth="lg"
										component="main"
										sx={{ mt: "35px", mb: "20px" }}>
										<div
											style={{
												backgroundColor: "#000",
												width: "100%",
												height: 1,
											}}
										/>
										<div
											style={{
												width: "75px",
												margin: "auto",
												top: "-13px",
												position: "relative",
											}}>
											<Typography
												sx={{
													backgroundColor: "#fff",
												}}>
												{
													messages?.joinNow
														?.create_new_account?.OR
												}
											</Typography>
										</div>
										<br></br>
									</Container>

									<Container  maxWidth="lg"  component="main" sx={{  }}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={4}>
                    <Button  variant="outlined" sx={{width: '100%', pt: 1.2, pb:1.2, pl: 5, pr:5, color: "#a0a0a0"  }} startIcon={<img src="/assets/imdb.png" style={{height: 25 ,  color: "#a0a0a0"}} alt="imdb "/>} disabled={true}>
                                            IMDb
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={4}>

                                            <Button  variant="outlined" sx={{width: '100%', pt: 1.2, pb:1.2, pl: 5, pr:5, color: "#a0a0a0" }} startIcon={<img src="/assets/Twitter.png" style={{height: 25 }} alt="twitter "/>} disabled={true}>
                                                Twitter
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Button  variant="outlined" sx={{width: '100%', pt: 1.2, pb:1.2, pl: 5, pr:5, color: "#a0a0a0" }} startIcon={<img src="/assets/Linkedin.png" style={{height: 25 }} alt="linkedin"/>} disabled={true}>
                                                Linkedin
                                            </Button>
                    </Grid>

                  </Grid>
                </Container>
								</Grid>
							</Box>
						</FormikProvider>
					</Grid>
					{/*<Grid item xs={4}>
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              mb: 2,
              height:  200,
              flexDirection:'column'
            }}
            >
              <Button variant="contained" sx={{pt: 1.2, pb:1.2, marginBottom: '10px', width:'100%', fontSize: 'larger'}} >Linkedin</Button>
              <Button variant="contained" sx={{pt: 1.2, pb:1.2, marginBottom: '10px', width:'100%', fontSize: 'larger'}} >Twitter</Button>
              <Button variant="contained" sx={{pt: 1.2, pb:1.2, marginBottom: '10px', width:'100%', fontSize: 'larger'}} >Google</Button>
            </Box>
          </Grid>*/}
				</Grid>
			</Container>
			<br></br>
			<br></br>
		</>
	);
}
